module.exports = __webpack_public_path__ + "img/app-gallery.ff54aa0a.png";